// extracted by mini-css-extract-plugin
export default {"subtleHeading":"PreparationCard_subtleHeading__CUAPk","list":"PreparationCard_list__wWqR2","listItem":"PreparationCard_listItem__b+UwF"};